const WHITE_SPACE_REGEX = /\s+/g

export function removeWhiteSpace(value: string) {
  return value.replace(WHITE_SPACE_REGEX, '')
}

export function lowerCaseFirstCharacter(value: string) {
  return value.charAt(0).toLowerCase() + value.slice(1)
}
